'use client'

import type { colors } from './badgeStyles'

export type { BadgeProps } from './Badge'
export type { BadgeButtonPropsWithRef } from './BadgeButton'

export type BadgeColor = keyof typeof colors

export { Badge } from './Badge'
export { BadgeButton } from './BadgeButton'
export { TouchTarget } from './TouchTarget'
